"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
const getTitle = (value, options, placeholder) => {
  if (value && value.length) {
    const match = (0, _find.default)(options).call(options, o => o.value === value);
    if (match) {
      return match.label;
    }
  } else if (placeholder) {
    return placeholder;
  } else if (options && options.length) {
    return options[0].label;
  }
};
var _default = exports.default = getTitle;